import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { MainEquiposTecnologicosComponent } from './main-equipos-tecnologicos/main-equipos-tecnologicos.component';
import { AgregarEquiposTecnologicosComponent } from './agregar-equipos-tecnologicos/agregar-equipos-tecnologicos.component';
import { ListaEquiposTecnologicosComponent } from './lista-equipos-tecnologicos/lista-equipos-tecnologicos.component';
import { MaterialModule } from 'src/app/material.module';
import { FormsModule } from '@angular/forms';
import { PrimeNgModule } from 'src/app/PrimeNg.module';



@NgModule({
  declarations: [
    MainEquiposTecnologicosComponent,
    AgregarEquiposTecnologicosComponent,
    ListaEquiposTecnologicosComponent
  ],
  imports: [
    CommonModule,
    MaterialModule,
    FormsModule,
    PrimeNgModule
  ],
  exports:[
    MainEquiposTecnologicosComponent,
    AgregarEquiposTecnologicosComponent,
    ListaEquiposTecnologicosComponent
  ]
})
export class EquiposTecnologicosModule { }
